import { useState } from "react";
import { getCompanyNames } from "../../../services/gsuite/sheets";
import { getPlatformData } from "../../../services/mongo/platforms";
import { getEcrImageNames } from "../../../services/aws/ecr";

const useScraperData = (scraperClass) => {
  const [companyNames, setCompanyNames] = useState([]);
  const [scraperVersionNames, setScraperVersionNames] = useState([]);
  const [platformOptionData, setPlatformOptionData] = useState([]);

  const fetchData = async () => {
    const [companyRes, scraperRes, platformRes] = await Promise.all([
      getCompanyNames(scraperClass),
      getEcrImageNames(),
      getPlatformData(),
    ]);

    // Fetch company names
    const companyData = await companyRes.json();
    setCompanyNames(companyData.company_names.sort());

    // Fetch scraper versions
    const scraperData = await scraperRes.json();
    const formattedVersions = scraperData.images.map(({ imageDigest: key, imageTag: val }) => ({
      key,
      val,
    }));
    setScraperVersionNames(formattedVersions);

    // Fetch platform names
    const platformData = await platformRes.json();
    setPlatformOptionData(platformData.platform_names);
  };

  return { companyNames, scraperVersionNames, platformOptionData, fetchData };
};
export default useScraperData;
